/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';
import { Button } from './ui/button';
import { TableCell, TableRow } from './ui/table';
import UserFormModal from './UserFormModal';
import UserReportsModal from './UserReports';

interface Props {
  row: any;
}

const UserTableRow: FC<Props> = ({ row }) => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showReportsModal, setShowReportsModal] = useState(false);

  return (
    <>
      <TableRow className="hover:bg-muted/30 cursor-pointer transition-colors">
        <>
          <TableCell className="py-3">
            {row.firstName} {row.lastName}
          </TableCell>
          <TableCell className="py-3">{row.emailAddress}</TableCell>
          <TableCell className="py-3">{row.phoneNumber ?? 'Unknown'}</TableCell>
          <TableCell className="py-3 flex justify-end gap-2">
            <Button
              onClick={() => setShowReportsModal(true)}
              className="py-1 h-fit"
            >
              View Report
            </Button>
            <Button
              onClick={() => setShowUpdateModal(true)}
              className="py-1 h-fit"
            >
              Edit User
            </Button>
          </TableCell>
        </>
      </TableRow>
      <UserFormModal
        agent={row}
        columns={['firstName', 'lastName', 'emailAddress', 'phoneNumber']}
        isOpen={showUpdateModal}
        setIsOpen={setShowUpdateModal}
      />
      <UserReportsModal
        isOpen={showReportsModal}
        setIsOpen={setShowReportsModal}
        client={row}
      />
    </>
  );
};

export default UserTableRow;
